import { availableCategoriesIds, availableItemsIds } from './clean-department-utils'
import _ from 'lodash'

export function cleanEntitySuggestions (entity, menuBlob) {
  if (_.has(entity, 'suggestions.categories')) {
    const availableCategories = availableCategoriesIds(menuBlob)
    _.remove(entity.suggestions.categories, ({ categoryId }) => !availableCategories.includes(categoryId))
  }

  if (_.has(entity, 'suggestions.items')) {
    const availableItems = availableItemsIds(menuBlob)
    _.remove(entity.suggestions.items, ({ itemId }) => !availableItems.includes(itemId))
    entity.suggestions.items
      .filter(it => it.selected)
      .sort((a, b) => a.order - b.order)
      .forEach((it, i) => (it.order = i))
  }
}
